import { Classes } from '@blueprintjs/core';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import ColorPickerButton from '../../color/picker/colorPickerButton';

const Letter = styled.span`
  margin-right: 0;
  font-size: 18px;
  line-height: 16px;
`;

const TextColorButton = ({ onChange, value }) => {
  const letter = <Letter>A</Letter>;
  const icon = <div className={Classes.ICON}>{letter}</div>;
  return (
    <ColorPickerButton
      icon={icon}
      onChange={onChange}
      placement="bottom"
      text="Text color"
      value={value}
    />
  );
};

TextColorButton.defaultProps = {
  onChange: () => {},
  value: undefined,
};

TextColorButton.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
};

export default TextColorButton;
